module.exports = __webpack_public_path__ + "static/media/chubbLogo2.81716512.png";